import { useParams } from "next/navigation";
import { Fragment } from "react";

import { LayoutSideMenu } from "@/types";

import { layoutVariant, type LayoutVariantProps } from "./layout.variants";

export type UseLayoutProps = LayoutVariantProps & {
  data: {
    docsMenu?: LayoutSideMenu[];
  };
  children?: React.ReactNode;
};

export const useLayout = (props: UseLayoutProps) => {
  const { data, children } = props;
  const params = useParams();
  const [page, category] = Array.isArray(params.slug) ? params.slug : [];
  const showSidebar = ["docs"].includes(page ?? "");
  const docsMenu = data.docsMenu?.find((item) => item.slug === category);

  const styles = layoutVariant({
    showSidebar,
  });

  const Comp = showSidebar ? "div" : Fragment;

  return {
    docsMenu,
    showSidebar,
    styles,
    children,
    Comp,
  };
};
